// Brand-icon-driven platform tiles for the "Compatible With…" carousel on
// enriched widget hub pages. Each entry's `iconHex` + `iconPath` come from
// the simple-icons package so the tile renders the brand mark in its
// native color — no wordmark text, no grayscale treatment.
//
// Server code in `[slug]/page.tsx` imports `DEFAULT_PLATFORM_TILES` to map
// slugs for the live-page DB filter (`getLivePlatformTilesForApp`). simple-
// icons is pure data (no React, no DOM), so this stays safely importable
// across the server/client boundary.
//
// Platform set rationale (2026-05-18 swap):
// Dropped (no simple-icons entry): magento, weebly, duda, jimdo,
//   shift4shop, unbounce.
// Added: notion, blogger, tumblr, framer, elementor, hubspot — all have
//   simple-icons entries AND meaningful GA4 landingPage traffic on our
//   widget hubs (esp. notion + blogger for creative/portfolio widgets).
import {
  siShopify,
  siWordpress,
  siWix,
  siWebflow,
  siNotion,
  siSquarespace,
  siFramer,
  siBigcommerce,
  siBlogger,
  siCarrd,
  siJoomla,
  siTumblr,
  siElementor,
  siHubspot,
} from "simple-icons";

export interface IPlatformTile {
  /** URL slug — also the spoke deep-link `/widgets/<hub>/<slug>`. */
  slug: string;
  /** Display name (aria-label + title tooltip only — never rendered as visible text). */
  name: string;
  /** Brand color hex (no `#` prefix, matches simple-icons.hex format). */
  iconHex: string;
  /** SVG path data (24x24 viewBox) for the brand mark. */
  iconPath: string;
}

export const DEFAULT_PLATFORM_TILES: IPlatformTile[] = [
  { slug: "shopify", name: "Shopify", iconHex: siShopify.hex, iconPath: siShopify.path },
  { slug: "wordpress", name: "WordPress", iconHex: siWordpress.hex, iconPath: siWordpress.path },
  { slug: "wix", name: "Wix", iconHex: siWix.hex, iconPath: siWix.path },
  { slug: "webflow", name: "Webflow", iconHex: siWebflow.hex, iconPath: siWebflow.path },
  { slug: "notion", name: "Notion", iconHex: siNotion.hex, iconPath: siNotion.path },
  { slug: "squarespace", name: "Squarespace", iconHex: siSquarespace.hex, iconPath: siSquarespace.path },
  { slug: "framer", name: "Framer", iconHex: siFramer.hex, iconPath: siFramer.path },
  { slug: "bigcommerce", name: "BigCommerce", iconHex: siBigcommerce.hex, iconPath: siBigcommerce.path },
  { slug: "blogger", name: "Blogger", iconHex: siBlogger.hex, iconPath: siBlogger.path },
  { slug: "carrd", name: "Carrd", iconHex: siCarrd.hex, iconPath: siCarrd.path },
  { slug: "joomla", name: "Joomla", iconHex: siJoomla.hex, iconPath: siJoomla.path },
  { slug: "tumblr", name: "Tumblr", iconHex: siTumblr.hex, iconPath: siTumblr.path },
  { slug: "elementor", name: "Elementor", iconHex: siElementor.hex, iconPath: siElementor.path },
  { slug: "hubspot", name: "HubSpot", iconHex: siHubspot.hex, iconPath: siHubspot.path },
];
